import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "ml-auto" }

import { ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Chip from 'primevue/chip';
import { useRelayHubStore } from '@/store';
import { EMIT } from '@/enum';
import { useArrayUtilities } from '@/composables';
import ConnectOrganizationModal from './ConnectOrganizationModal.vue';
import EditOrganizationModal from './EditOrganizationModal.vue';
import { TreeNode } from 'primevue/treenode';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationTable',
  setup(__props, { emit: __emit }) {

const relayHubStore = useRelayHubStore();

const showAddOrganizationModal = ref(false);
const showEditOrganizationModal = ref(false);
const { connectedOrganizations, selectedOrganizationIds, originalConnectedOrganizationIds } =
  storeToRefs(relayHubStore);

const selectedOrganization = ref<TreeNode | null>(null);

const emit = __emit;

const openEditOrganization = () => {
  showEditOrganizationModal.value = true;
};

const closeEditOrganization = () => {
  showEditOrganizationModal.value = false;
};

const openAddOrganizations = () => {
  showAddOrganizationModal.value = true;
};

const closeAddOrganizations = () => {
  showAddOrganizationModal.value = false;
};

const handleOrganizationConnected = () => {
  closeAddOrganizations();
  emit(EMIT.RESET);
};

const onCancel = async () => {
  emit(EMIT.RESET);
};

const handleEdit = (item: TreeNode) => {
  selectedOrganization.value = item;
  openEditOrganization();
};

const handleDelete = async (id: number) => {
  await relayHubStore.disableMedicaid([id], 'organizations');
  if (relayHubStore.error) relayHubStore.doToast(relayHubStore.error as string, 'Error', true);
  else relayHubStore.doToast('Organization Deleted');
  emit(EMIT.RESET);
};

const onSave = async () => {
  await relayHubStore.saveOrganizationMedicareAssignments();
  if (relayHubStore.error) relayHubStore.doToast(relayHubStore.error as string, 'Error', true);
  else relayHubStore.doToast('Organization Changes Saved');

  emit(EMIT.RESET);
};

const createMenuModel = (item: TreeNode) => {
  return [
    {
      label: 'Edit',
      command: () => handleEdit(item),
    },
    {
      label: 'Delete',
      command: () => handleDelete(item.id),
    },
  ];
};

const shouldDisable = computed(() =>
  useArrayUtilities().twoNumericArraysContainSameData(
    selectedOrganizationIds.value,
    originalConnectedOrganizationIds.value,
  ),
);

const handleOrganizationUpdated = () => {
  closeEditOrganization();
};

const organizationCount = computed(() => connectedOrganizations.value?.length);

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_ActionMenu = _resolveComponent("ActionMenu")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Organizations", -1)),
      _createVNode(_unref(Chip), null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(organizationCount.value), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_AppButton, {
          type: "text",
          size: "small",
          text: "Add Organization",
          "icon-left": "add",
          onClick: openAddOrganizations
        })
      ])
    ]),
    content: _withCtx(() => [
      (showAddOrganizationModal.value)
        ? (_openBlock(), _createBlock(ConnectOrganizationModal, {
            key: 0,
            onCancel: closeAddOrganizations,
            onSave: handleOrganizationConnected
          }))
        : _createCommentVNode("", true),
      (showEditOrganizationModal.value)
        ? (_openBlock(), _createBlock(EditOrganizationModal, {
            key: 1,
            organization: selectedOrganization.value,
            onCancel: closeEditOrganization,
            onSave: handleOrganizationUpdated
          }, null, 8, ["organization"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(DataTable), {
        value: _unref(connectedOrganizations),
        loading: _unref(relayHubStore).loading
      }, {
        empty: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("There are no Organizations connected", -1)
        ]))]),
        default: _withCtx(() => [
          _createVNode(_unref(Column), {
            "header-style": "width: 4em",
            class: "text-center"
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_Checkbox, {
                modelValue: _unref(selectedOrganizationIds),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedOrganizationIds) ? (selectedOrganizationIds).value = $event : null)),
                name: slotProps.data.name,
                value: slotProps.data.id
              }, null, 8, ["modelValue", "name", "value"])
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "name",
            header: "Organization"
          }),
          _createVNode(_unref(Column), {
            field: "medicaid_district_code",
            header: "Medicaid District Code"
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("span", null, _toDisplayString(data.medicaid_district_code || 'N/A'), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "actions",
            header: "Actions",
            "header-style": "width: 4em",
            class: "text-center"
          }, {
            body: _withCtx(({ data }) => [
              _createVNode(_component_ActionMenu, {
                "menu-items": createMenuModel(data),
                icon: "more_horiz"
              }, null, 8, ["menu-items"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "loading"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_AppButton, {
        text: "Cancel",
        type: "secondary",
        disabled: shouldDisable.value,
        onClick: onCancel
      }, null, 8, ["disabled"]),
      _createVNode(_component_AppButton, {
        text: "Save",
        type: "primary",
        disabled: shouldDisable.value,
        onClick: onSave
      }, null, 8, ["disabled"])
    ]),
    _: 1
  }))
}
}

})